import { useTranslation } from "react-i18next"
import { SimpleWorkArea } from "../../../../../@client/Theasoft_ApiServer_WorkAreas"
import { Checkbox, Stack, Button } from "@mantine/core"

type Props = {
  workareas: SimpleWorkArea[]
  selectedWorkareaIds: number[] | null
  onSetSelectedWorkareaIds: (
    selectedWorkareaIds: number[] | null | undefined
  ) => void
}

export function WorkareaFilter({
  workareas,
  selectedWorkareaIds,
  onSetSelectedWorkareaIds,
}: Props) {
  const { t } = useTranslation("app_server")
  return (
    <Stack gap={0}>
      <Button
        variant="default"
        size="xs"
        onClick={() => {
          if (selectedWorkareaIds == null) {
            onSetSelectedWorkareaIds([])
          } else {
            onSetSelectedWorkareaIds(null)
          }
        }}
      >
        {selectedWorkareaIds == null ? t("UncheckAll") : t("CheckAll")}
      </Button>

      <Stack p="xs" gap="xs">
        {workareas.map((v, i) => (
          <Checkbox
            key={i}
            checked={
              selectedWorkareaIds?.includes(v.workAreaId) ||
              selectedWorkareaIds == null
            }
            onChange={(e) => {
              const selected =
                selectedWorkareaIds === null
                  ? workareas.map((v) => v.workAreaId)
                  : selectedWorkareaIds
              if (e.target.checked) {
                onSetSelectedWorkareaIds([...selected, v.workAreaId])
              } else {
                onSetSelectedWorkareaIds(
                  selected.filter((x) => x !== v.workAreaId)
                )
              }
            }}
            label={v.name}
          />
        ))}
      </Stack>
    </Stack>
  )
}
